import React, { useEffect, useState } from 'react';
import { Layout, Typography, Row, Col, Spin, theme } from 'antd';
import ExpensesWidget from '../shared-components/ExpensesWidget';
import StockStateWidget from '../shared-components/StockStateWidget';
import ProductionStateWidget from '../shared-components/ProductionStateWidget';

const { Content } = Layout;
const { Title } = Typography;

// Mock data - replace with actual API calls in production
const mockData = {
  expenses: {
    totalExpenses: 125430.75,
    totalDonates: 23450.50,
    totalSales: 187920.25,
    currentBalance: 85940.00,
  },
  stock: {
    stockItemsCost: 65250.75,
    incomingItemsCost: 18750.25,
  },
  production: [
    { key: '1', stage: 'Design', count: 12 },
    { key: '2', stage: 'Prototype', count: 8 },
    { key: '3', stage: 'Testing', count: 15 },
    { key: '4', stage: 'Assembly', count: 24 },
    { key: '5', stage: 'Quality Control', count: 18 },
    { key: '6', stage: 'Packaging', count: 30 },
  ],
};

function HomePageV2() {
  const { token } = theme.useToken();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(mockData);

  useEffect(() => {
    // Simulate API call
    const fetchData = async () => {
      try {
        // In a real application, replace this with actual API calls
        // const expensesData = await fetchExpensesData();
        // const stockData = await fetchStockData();
        // const productionData = await fetchProductionData();
        
        // setDashboardData({
        //   expenses: expensesData,
        //   stock: stockData,
        //   production: productionData,
        // });

        // For demo, we'll use mock data and simulate loading
        setTimeout(() => {
          setDashboardData(mockData);
          setLoading(false);
        }, 1000);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const dashboardStyle = {
    background: token.colorBgContainer,
    borderRadius: token.borderRadiusLG,
    padding: 24,
    marginBottom: 24,
    width: '100%',
    
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="Loading dashboard..." />
      </div>
    );
  }

  return (
    <Layout style={{ padding: '24px' }}>
      <Content>
        <Title level={2} style={{ marginBottom: 24 }}>Drone Parts Dashboard</Title>
        
        <div style={dashboardStyle}>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={4}>
              <ExpensesWidget 
                totalExpenses={dashboardData.expenses.totalExpenses}
                totalDonates={dashboardData.expenses.totalDonates}
                totalSales={dashboardData.expenses.totalSales}
                currentBalance={dashboardData.expenses.currentBalance}
              />
            </Col>
            
            <Col xs={24} md={4}>
              <StockStateWidget 
                stockItemsCost={dashboardData.stock.stockItemsCost}
                incomingItemsCost={dashboardData.stock.incomingItemsCost}
              />
            </Col>
            
            <Col xs={24} md={4}>
              <ProductionStateWidget 
                productionStages={dashboardData.production}
              />
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
}

export default HomePageV2;
